import { STORAGE_PREFIX } from "./storage-keys";

export const STORAGE_KEYS = {
  AUTH: {
    ACCESS_TOKEN: `${STORAGE_PREFIX}.auth.accessToken`,
    REFRESH_TOKEN: `${STORAGE_PREFIX}.auth.refreshToken`,
    SIGN_IN_PATH: `${STORAGE_PREFIX}.auth.signInPath`,
    USER_INFO: `${STORAGE_PREFIX}.auth.userInfo`,
    USERNAME: `${STORAGE_PREFIX}.auth.username`
  },

  UI: {
    LAYOUT: `${STORAGE_PREFIX}.ui.layout`,
    OPPORTUNITY_LIST_COLUMNS: `${STORAGE_PREFIX}.ui.opportunityList.columns`,
    OPPORTUNITY_TRANSFER_LIST_COLUMNS: `${STORAGE_PREFIX}.ui.opportunityTransferList.columns`,
    SCHEME: `${STORAGE_PREFIX}.ui.scheme`,
    THEME: `${STORAGE_PREFIX}.ui.theme`
  }
} as const;

export type StorageKey =
  | typeof STORAGE_KEYS.AUTH[keyof typeof STORAGE_KEYS.AUTH]
  | typeof STORAGE_KEYS.UI[keyof typeof STORAGE_KEYS.UI];
